import Component from '../../shared/component';

const FORM_CLASS = 'internshipResponse-form';
const FORM_VISIBLE_CLASS = 'internshipResponse-form--visible';
const TOGGLE_OPTION_CLASS = 'internshipResponse-toggle-option';
const TOGGLE_OPTION_ACTIVE_CLASS = 'internshipResponse-toggle-option--active';

export default class InternshipResponse extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$toggleOptions = this.$element.find(`.${TOGGLE_OPTION_CLASS}`);
    this.$forms = this.$element.find(`.${FORM_CLASS}`);

    this.bindEvents();
  }

  bindEvents() {
    this.handleToggleOptionClick = this.handleToggleOptionClick.bind(this);

    this.$toggleOptions.on(
      'click.InternshipResponse',
      this.handleToggleOptionClick
    );
  }

  unbindEvents() {
    this.$toggleOptions.off(
      'click.InternshipResponse',
      this.handleToggleOptionClick
    );
  }

  handleToggleOptionClick(event) {
    const $toggleOption = $(event.target).closest(`.${TOGGLE_OPTION_CLASS}`);
    const $form = this.$element.find(
      `.${FORM_CLASS}[data-form-name="${$toggleOption.data('formName')}"]`
    );

    this.$forms.removeClass(FORM_VISIBLE_CLASS);
    $form.addClass(FORM_VISIBLE_CLASS);

    this.$toggleOptions.removeClass(TOGGLE_OPTION_ACTIVE_CLASS);
    $toggleOption.addClass(TOGGLE_OPTION_ACTIVE_CLASS);
  }
}
